import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { firstValueFrom } from 'rxjs';
import { AppConsts } from '../../AppConsts';
import { ExternalSystemDto, ExternalSystemService } from 'src/app/proxy/external-systems';

@Component({
  selector: 'app-external-system-multiselector',
  standalone: false,
  templateUrl: './external-system-multiselector.component.html',
})
export class ExternalSystemMultiselectorComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() externalSystemIdsSelected: number[] = [];
  @Input() isDisabled = false;

  @Output() changeSelectedExternalSystems = new EventEmitter<ExternalSystemDto[]>();
  externalSystems: ExternalSystemDto[];
  selectedExternalSystems: ExternalSystemDto[] = [];

  constructor(
    injector: Injector,
    private readonly _externalSystemService: ExternalSystemService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadExternalSystems();
    this.onSelected();
  }

  async loadExternalSystems(): Promise<void> {
    try {
      this.showLoading();

      const result = await firstValueFrom(this._externalSystemService.getAllByInput({
        maxResultCount: AppConsts.MaxPageSize,
        skipCount: 0
      }));

      this.externalSystems = result.items;
    } finally {
      this.hideLoading();
    }
  }

  onSelected(): void {
    this.changeSelectedExternalSystems.emit(this.selectedExternalSystems);
  }

  async setSelectedExternalSystemsByIds(externalSystemIds: number[]): Promise<void> {
    this.externalSystemIdsSelected = externalSystemIds || [];

    if (this.isNullOrUndefined(this.externalSystems)) {
      await this.loadExternalSystems();
    }
    
    this.setSelectedExternalSystems();
  }

  private setSelectedExternalSystems(): void {
    if (this.externalSystems?.length && this.externalSystemIdsSelected?.length) {
      this.selectedExternalSystems = this.externalSystems.filter(x => 
        this.externalSystemIdsSelected.includes(x.id)
      );
      this.onSelected();
    }
  }
}